import { render } from "./modalGeneric.vue?vue&type=template&id=17a41030&scoped=true"
import script from "./modalGeneric.vue?vue&type=script&lang=js"
export * from "./modalGeneric.vue?vue&type=script&lang=js"

import "./modalGeneric.vue?vue&type=style&index=0&id=17a41030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a41030"]])

export default __exports__